import { create } from 'zustand';
import { createJSONStorage, devtools, persist, } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { createFieldsSlice } from './FormFieldsSlice/formFieldsSlice';
import { FormFieldsSlice } from './FormFieldsSlice/formFieldsTypes';
import { FormImagesSlice } from './FormImagesSlice/formImagesTypes';
import { createImagesSlice } from './FormImagesSlice/useFormImagesSlice';
import { createNavigationSlice } from './NavigationDataSlice/NavigationDataSlice';
import { NavigationDataSlice } from './NavigationDataSlice/NavigationDataTypes';

export const useUploadProductStore = create(
  devtools(
    persist(
      immer<FormImagesSlice & FormFieldsSlice & NavigationDataSlice>(
        (...a) => ({
          ...createImagesSlice(...a),
          ...createFieldsSlice(...a),
          ...createNavigationSlice(...a),
          })
        ), 
        {
          name: 'uploadProductFormFields',
          storage: createJSONStorage(() => sessionStorage)
        },
    ),
  )
)